import { cn } from "@/lib/utils";

interface SkeletonProps {
    className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
    return (
        <div
            className={cn(
                "animate-pulse rounded-md bg-gray-200 dark:bg-gray-700",
                className
            )}
        />
    );
}

export function SkeletonCard() {
    return (
        <div className="card p-4">
            <div className="flex flex-col sm:flex-row sm:items-start gap-4">
                {/* Vote section skeleton */}
                <div className="flex sm:flex-col items-center gap-2">
                    <Skeleton className="w-8 h-8 rounded-full" />
                    <Skeleton className="w-12 h-6" />
                    <Skeleton className="w-8 h-8 rounded-full" />
                </div>

                {/* Content skeleton */}
                <div className="flex-1 space-y-3">
                    <Skeleton className="h-6 w-3/4" />
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-2/3" />
                    <div className="flex gap-2 mt-2">
                        <Skeleton className="h-4 w-24" />
                        <Skeleton className="h-4 w-20" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export function SkeletonRow() {
    return (
        <div className="card flex items-center gap-4 p-4">
            <Skeleton className="w-12 h-12 rounded-full flex-shrink-0" />
            <div className="flex-1 space-y-2">
                <Skeleton className="h-5 w-3/4" />
                <Skeleton className="h-4 w-1/4" />
            </div>
            <Skeleton className="h-6 w-12" />
        </div>
    );
}
